module.exports = __webpack_public_path__ + "img/615.9a4ea22a.png";